import type { Step } from "react-joyride";

export const kpiTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການ KPI! KPI (Key Performance Indicator) ແມ່ນຕົວຊີ້ວັດຜົນການປະຕິບັດງານທີ່ຊ່ວຍວັດແລະປະເມີນຜົນການເຮັດວຽກຂອງອົງກອນ, ພະແນກກ, ຫຼືພະນັກງານ. ທ່ານສາມາດສ້າງ KPI ສຳລັບການວັດຜົນການເຮັດວຽກ, ການປະເມີນພະນັກງານ, ຫຼືການຕິດຕາມຜົນການດຳເນີນງານ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="kpi-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງ KPI ໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງ KPI ທີ່ທ່ານຕ້ອງການ. KPI ຈະຊ່ວຍທ່ານວັດແລະປະເມີນຜົນການເຮັດວຽກຂອງພະນັກງານ, ພະແນກກ, ຫຼືອົງກອນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="kpi-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາ KPI ຕາມຊື່, ລະດັບ, ສະຖານະ, ຮອບການວັດ, ຫຼືພະແນກກ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="kpi-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງ KPI ທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຄັດລອກ, ປິດການໃຊ້ງານ, ຫຼືລຶບ KPI ໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະ KPI. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງ KPI ແຕ່ລະຕົວ.",
    placement: "top",
  },
];
